module.exports = __webpack_public_path__ + "media/Video 19.7237476c.mp4";